/*!
 * JavaScript for Energy Helpline pages
 * Give as you Live Ltd
 */

// Import SASS/SCSS styles
import 'Sass/landingpage.scss';

// Import modules
const LandingPage = require('Scripts/landingpage/landingpage');
const Loader      = require('Scripts/common/loader');
const OwlCarousel = require('Scripts/common/owl-carousel');
const PreShop     = require('Scripts/gayl/pre-shop');

// Define groups of modules - the group name is set in your template ($jsModuleGroup). 
// This is just a nicer way to load JS on specific pages without looking at the path/params
// To initiate a group, use the #module macro. E.g. #module("my-group") would add 'my-group' from the groups below.
const moduleGroups = {
	// Available on every page
	'global': [LandingPage, PreShop, OwlCarousel],
};

Loader.load(moduleGroups);